var _path, _path2, _path3, _path4, _ellipse, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookingconfirmIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.9682 37.6766V23.7611C70.9682 23.7611 71.2461 19.2465 68.4999 16.0002C65.7537 12.754 61.9201 12.592 61.9201 12.592H17.5846C17.5846 12.592 12.5116 12.0922 8.99992 16.0002C5.48824 19.9082 6.00302 23.7611 6.00302 23.7611V60.3808C6.00302 60.3808 5.84968 64.8521 8.49942 67.5004C12.1422 71.1413 16.5044 71.1836 16.5044 71.1836H36.5912",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6387 6V17.3521",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9824 6V17.3521",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.18945 28.8872H70.7927",
    stroke: "white",
    strokeWidth: 4
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.6241,
    cy: 59.8873,
    rx: 22.6202,
    ry: 22.8873,
    fill: "#235B05"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.998 61.5C80.998 72.5623 72.1395 81.5 61.249 81.5C50.3585 81.5 41.5 72.5623 41.5 61.5C41.5 50.4377 50.3585 41.5 61.249 41.5C72.1395 41.5 80.998 50.4377 80.998 61.5Z",
    stroke: "white",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4316 61.2961C51.8659 61.7355 57.524 67.9487 60.2987 71.0003L73.5089 53.606",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingconfirmIcon1);
export default __webpack_public_path__ + "static/media/booking confirm_icon (1).0a31d88e1f87c14a38d26e1da377bba8.svg";
export { ForwardRef as ReactComponent };